import * as React from "react";

import ClassNames from "classnames";
import InputLabel from "../InputLabel";
import Typography from "../Typography";
import Styles from "./Select.module.css";
export interface Props {
  className?: string;
  compact?: boolean;
  placeholder?: string;
  defaultValue?: string;
  fullWidth?: boolean;
  helperText?: string;
  hideLabel?: boolean;
  label: string;
  name?: string;
  options: any;
  id: string;
  errors?: string[];
  required?: boolean;
  nativeRequired?: boolean;
  multiSelect?: boolean;
  inputRef?: any;
  onChange?: any;
  value?: string;
}

export interface OptionProps {
  label?: string;
  value?: string;
  disabled?: boolean;
}

const Option: React.FC<OptionProps> = props => {
  const { label, value, disabled } = props;

  return (
    <option value={value} disabled={disabled}>
      {label}
    </option>
  );
};

const Select: React.FC<Props> = props => {
  const {
    label,
    className,
    compact = false,
    placeholder,
    helperText,
    name,
    defaultValue,
    fullWidth,
    hideLabel,
    options,
    errors,
    inputRef,
    required,
    nativeRequired,
    id,
    multiSelect,
    onChange = () => {
      /* intentionally empty */
    },
    value
  } = props;

  return (
    <div className={Styles.wrapper}>
      <InputLabel
        label={label}
        htmlFor={id}
        required={required}
        nativeRequired={nativeRequired}
        hideLabel={hideLabel}
      />
      <select
        id={id}
        name={name}
        onChange={onChange}
        value={value}
        className={ClassNames({
          [Styles.select]: true,
          [Styles.fullWidth]: fullWidth,
          [Styles.compact]: compact,
          [className]: className
        })}
        required={nativeRequired}
        defaultValue={defaultValue}
        multiple={multiSelect}
        ref={inputRef}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map(option => (
          <Option {...option} key={option.label.replace(/\s/g, "")} />
        ))}
      </select>
      {helperText && (
        <Typography body="small" className={Styles.helper}>
          {helperText}
        </Typography>
      )}
      {errors &&
        errors.map((error, i) => {
          return (
            <Typography
              body="small"
              className={ClassNames({
                [Styles.error]: true,
                [Styles.firstError]: errors.length !== 1 && i === 0
              })}
              key={`error-${id}-${i}`}
            >
              {error}
            </Typography>
          );
        })}
    </div>
  );
};

export default Select;
